let html = `<div class="activitys layer--width">
    <div class="activitys__slides"></div>
</div>`

export default html